import React, { useState, useRef, useEffect } from 'react'
import { styled } from 'linaria/react'
import ListCardSkeleton from '../Skeletons/ListCardSkeleton'
import ProductListCard from '../Cards/ProductListCard'
import { theme } from '../../Theme'
import NoProductsFound from '../../CategoryPage/Widgets/NoProductsFound'

const NoProductHitsContainer = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   text-align: center;
   min-height: 8rem;
   max-height: 35rem;
   height: 100%;
`

const ProductGridContainer = styled.div`
   @media (max-width: 576px) {
      &.gx-3 {
         --bs-gutter-x: 0.5rem !important;
      }
   }

   ${theme.above.xxl} {
      .col-xxl-3 {
         flex: 0 0 auto;
         width: calc(100% / 4);
      }
   }

   ${theme.above.xxxxl} {
      .col-xxxl-2 {
         flex: 0 0 auto;
         width: calc(100% / 6);
      }
   }
`

const ProductHitsGrid = ({ products, productSettings, loadingCardsCount, loading }) => {
   const [showSkeletons, setShowSkeletons] = useState(true);
   const isFirstLoad = useRef(true);
   const timeoutRef = useRef(null);
   const SKELETON_DELAY_MS = 200;

   useEffect(() => {
      if (!products && !loading) return; // Prevents unnecessary effect calls
   
      if (isFirstLoad.current) {
         setShowSkeletons(prev => (prev === (loading || products === null) ? prev : (loading || products === null)));
         isFirstLoad.current = false; // Mark first load complete
         return;
      }
   
      if (loading) {
         // Delay skeletons to prevent flickering
         timeoutRef.current = setTimeout(() => {
            setShowSkeletons(prev => (prev === true ? prev : true));
         }, SKELETON_DELAY_MS);
      } else {
         // Show products immediately when loaded
         setShowSkeletons(prev => (prev === false ? prev : false));
      }
   
      return () => clearTimeout(timeoutRef.current);
   }, [loading, products]);

   return (
      <>
         <ProductGridContainer className="row gy-3 gx-3">
            {!showSkeletons ? (
               products?.map((product, index) => (
                  <div
                     className="col-6 col-sm-6 col-xl-4 col-xxl-3 col-xxxl-2 d-flex"
                     key={index}
                  >
                     <ProductListCard
                        product={product}
                        productSettings={productSettings}
                     />
                  </div>
               ))
            ) : (
               <>
                  {Array.from({ length: loadingCardsCount }, (_, i) => (
                     <div
                        className="col-6 col-sm-6 col-xl-4 col-xxl-3 col-xxxl-2"
                        key={i}
                     >
                        <ListCardSkeleton />
                     </div>
                  ))}
               </>
            )}
         </ProductGridContainer>
         {products?.length === 0 && !showSkeletons && !loading && (
            <NoProductHitsContainer className="col-12 py-128 px-128">
               <NoProductsFound />
            </NoProductHitsContainer>
         )}
      </>
   )
}

export default ProductHitsGrid

